<template>
  <div class="generic-delete-background" @click="cancel">
    <div class="generic-delete-container">
      <div class="generic-delete-title">Delete {{ thingName }}</div>
      <div class="generic-delete-subtitle">
        Are you sure you want to delete this {{ thingName }}?
      </div>
      <div class="generic-delete-buttons-container">
        <div class="generic-delete-confirm" @click="confirm()">Yes, Delete</div>
        <div class="generic-delete-cancel" @click="cancel()">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    thingName: String
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style scoped>
.generic-delete-background {
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  left: 0;
  top: 0;
  z-index: 13;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.generic-delete-container {
  width: 400px;
  height: 150px;
  background: white;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2%;
  border-radius: 4px;
}
.generic-delete-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 22px;
  color: #df000f;
}
.generic-delete-subtitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  color: #192a3e;
}

.generic-delete-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.generic-delete-confirm {
  width: 150px;
  height: 48px;
  background: #df000f;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  color: #ffffff;
}

.generic-delete-cancel {
  width: 150px;
  height: 48px;
  background: white;
  border-radius: 4px;
  border: 1px solid #4a4a4a;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  color: #4a4a4a;
}

.generic-delete-confirm:hover,
.generic-delete-cancel:hover {
  cursor: pointer;
}
</style>
